import { makeAutoObservable, runInAction } from "mobx";
import { SearchRequest, FilterItem, Search } from "../api/Types";
import {
  PerPageSettings,
  WithBooleanFlag,
  Sorter,
  ExpandableKeys,
} from "./core";
import ApiLists from "../modules/api/Lists";

export class SystemDictionariesStore {
  data = [];
  dataIsLoading = new WithBooleanFlag();
  dataRowKeys = new ExpandableKeys();
  paginator = new PerPageSettings();
  sorter = new Sorter();
  filterItems: FilterItem[] = [];
  search: { text: string } = {
    text: "",
  };
  searchAbortController = null;

  constructor() {
    makeAutoObservable(this);
  }

  getData = async () => {
    if (this.searchAbortController) {
      this.searchAbortController.abort();
    }
    this.searchAbortController = new AbortController();

    try {
      this.dataIsLoading.setTrue();
      const request: SearchRequest = {
        page: this.paginator.page,
        count: this.paginator.perPage,
        sortItems: this.sorter.sortData,
        filterItems: this.filterItems,
        search: this.search,
      };
      const { data } = await ApiLists.getDicts(request, {
        signal: this.searchAbortController.signal,
      });
      if (!this.searchAbortController.signal.aborted) {
        runInAction(() => {
          this.data = data.items;
          this.paginator.updateMeta(data);
        });
        this.dataIsLoading.setFalse();
      }
    } catch (error) {
      console.log(error);
      if(error.message !== 'canceled') {
        this.dataIsLoading.setFalse();
      }
    }
  };
}

export default new SystemDictionariesStore();
